<template>
  <div class="mb-3 mt-3">
    <b-container>
      <h1 class="text-primary font-weight-bold text-center mb-5">{{ $t('measure_create.title') }}</h1>
      <measure-form :colony="colony" :apiary="apiary" :type="type"></measure-form>
    </b-container>
  </div>
</template>

<script>
import MeasureForm from '../components/MeasureForm'
export default {
  name: 'MeasureCreate',
  props: ['apiary', 'colony', 'type'],
  components: { MeasureForm }
}
</script>

<style scoped>

</style>
